import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleClassName", "contentClassName", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import { default as _Popover } from 'react-bootstrap/Popover';
import Tooltip from '../tooltip/Tooltip';
var Popover = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var title = props.title,
    _props$titleClassName = props.titleClassName,
    titleClassName = _props$titleClassName === void 0 ? '' : _props$titleClassName,
    _props$contentClassNa = props.contentClassName,
    contentClassName = _props$contentClassNa === void 0 ? '' : _props$contentClassNa,
    children = props.children,
    remainingProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_Popover, _extends({
    ref: ref
  }, remainingProps), title && /*#__PURE__*/React.createElement(_Popover.Title, {
    className: "popover-title ".concat(titleClassName)
  }, title), children && /*#__PURE__*/React.createElement(_Popover.Content, {
    className: "popover-content ".concat(contentClassName)
  }, children));
});
Popover.AUTO = Tooltip.AUTO;
Popover.TOP = Tooltip.TOP;
Popover.BOTTOM = Tooltip.BOTTOM;
Popover.RIGHT = Tooltip.RIGHT;
Popover.LEFT = Tooltip.LEFT;
Popover.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  titleClassName: PropTypes.string,
  contentClassName: PropTypes.string
};
export default Popover;